export const getters = {
    GET_BUSINESS_TYPES:(state)=>state.businessTypes,
    GET_BUSINESS_TYPE:(state)=>state.businessType
  }
  